import { Button, Form, message, Modal, Select } from "antd";
import TextArea from "antd/es/input/TextArea";
import { useState } from "react";

export function ContactStatusSelect({ contact, onStatusChange }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();

  const getStatusOptions = () => [
    { value: "pending", label: "Chờ xử lý" },
    { value: "replied", label: "Đã trả lời" },
    { value: "closed", label: "Đã đóng" },
  ];

  const handleStatusChange = async (newStatus) => {
    if (newStatus === "replied") {
      setIsModalOpen(true);
    } else {
      try {
        await onStatusChange(contact._id, { status: newStatus });
        message.success("Cập nhật trạng thái thành công!");
      } catch (error) {
        message.error("Cập nhật trạng thái thất bại!");
      }
    }
  };

  const handleReplySubmit = async (values) => {
    try {
      await onStatusChange(contact._id, {
        status: "replied",
        replyContent: values.replyContent,
      });
      message.success("Trả lời thành công!");
      setIsModalOpen(false);
      form.resetFields();
    } catch (error) {
      message.error("Trả lời thất bại!");
    }
  };

  return (
    <>
      <Select
        value={contact.status}
        onChange={handleStatusChange}
        style={{ width: 120 }}
        options={getStatusOptions()}
      />

      {/* Reply Modal */}
      <Modal
        title="Trả lời tin nhắn liên hệ"
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
        width={600}
      >
        <div className="mb-4 p-4 bg-gray-50 rounded">
          <h4 className="font-medium mb-2">Thông tin người liên hệ:</h4>
          <p>
            <strong>Tên:</strong> {contact.name}
          </p>
          <p>
            <strong>Email:</strong> {contact.email}
          </p>
          <p>
            <strong>Tiêu đề:</strong> {contact.title}
          </p>
        </div>

        <div className="mb-4 p-4 bg-blue-50 rounded">
          <h4 className="font-medium mb-2">Nội dung gốc:</h4>
          <p className="whitespace-pre-wrap">{contact.content}</p>
        </div>

        <Form form={form} onFinish={handleReplySubmit} layout="vertical">
          <Form.Item
            name="replyContent"
            label="Nội dung trả lời"
            rules={[
              { required: true, message: "Vui lòng nhập nội dung trả lời" },
              { min: 10, message: "Nội dung trả lời phải có ít nhất 10 ký tự" },
            ]}
          >
            <TextArea
              rows={6}
              placeholder="Nhập nội dung trả lời cho người liên hệ..."
            />
          </Form.Item>

          <div className="flex justify-end space-x-2">
            <Button onClick={() => setIsModalOpen(false)}>Hủy</Button>
            <Button type="primary" htmlType="submit">
              Gửi trả lời
            </Button>
          </div>
        </Form>
      </Modal>
    </>
  );
}
